// project-imports
import {
  GET_STATS_BEGIN,
  GET_STATS_SUCCESS,
  GET_STATS_FAILURE,
  GET_FILTERED_STATS_BEGIN,
  GET_FILTERED_STATS_SUCCESS,
  GET_FILTERED_STATS_FAILURE,
} from "../constants/actions";

// State variable initialization
export const initialState = {
  isLoading: false,
  error: null,
  statsData: {},
  filterData: {},
};

const statsReducer = (state = initialState, action) => {
  if (action.type === GET_STATS_BEGIN) {
    // Set loading state
    return {
      ...state,
      isLoading: action.payload,
      error: null,
    };
  }

  if (action.type === GET_STATS_SUCCESS) {
    // Update state with all instructor
    return {
      ...state,
      isLoading: false,
      statsData: action.payload,
      error: null,
    };
  }

  if (action.type === GET_STATS_FAILURE) {
    // Set error state
    return {
      ...state,
      isLoading: false,
      error: action.payload,
    };
  }

  if (action.type === GET_FILTERED_STATS_BEGIN) {
    // Set loading state
    return {
      ...state,
      isLoading: action.payload,
      error: null,
    };
  }

  if (action.type === GET_FILTERED_STATS_SUCCESS) {
    // Update state with all instructor
    return {
      ...state,
      isLoading: false,
      filterData: action.payload,
      error: null,
    };
  }

  if (action.type === GET_FILTERED_STATS_FAILURE) {
    // Set error state
    return {
      ...state,
      isLoading: false,
      error: action.payload,
    };
  }
  return state;
};

export default statsReducer;
